<ht-modal [options]="modalOptions" (closeModalOutput)="onClose()" #modal>
  <div class="modal-content">
    <p>{{ 'auth.login.ensModal.intro' | translate }} </p>

    <p> {{ 'auth.login.ensModal.confirmPrefix' | translate }} </p>

    <ul>
      <li>
        {{ 'auth.login.ensModal.bulletDataProtection' | translate }}
      </li>
      <li>
        {{ 'auth.login.ensModal.bulletSecurityStandards' | translate }}
      </li>
      <li>
        {{ 'auth.login.ensModal.bulletUnauthorized' | translate }}
      </li>
    </ul>
  </div>
</ht-modal>
